module.exports = __webpack_public_path__ + "static/img/openTri.10f2137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/newIcon/openTri.png
// module id = ouSW
// module chunks = 1